import React, { useEffect, useRef, useState } from "react";
import { Form } from "@unform/web";
import { Row, Col, Button, Card } from "reactstrap";
import { ValidationError } from "yup";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

import InputUnform from "../../../components/unformInput";
import AsyncSelect from "../../../components/AsyncSelect";

import api from "../../../services/api";

import criarMarcaValidator from "../../../validations/criarMarcaValidator";

function CriarMarca() {
  const [key, setKey] = useState(null);

  const [image, setImage] = useState(null);
  const [erroImagem, setErroImagem] = useState(false);

  const [segmento, setSegmento] = useState(null);
  const [erroSegmento, setErroSegmento] = useState(false);

  const formRef = useRef(null);
  const imageRef = useRef(null);

  let timeoutConsulta;

  async function handleSubmit(data) {
    setErroSegmento(false);
    setErroImagem(false);
    formRef.current.setErrors([]);
    try {
      await criarMarcaValidator(data);
      if (image !== null && segmento !== null) {
        Swal.fire({
          title: "Aguarde",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        if (image) {
          var formData = new FormData();
          formData.append("file", image);

          try {
            const { data: foto_salva } = await api.post("/imagens", formData);
            data.imagem_id = foto_salva.id;
          } catch (e) {
            toast.error("Erro ao salvar imagem!");
          }
        }
        data.segmento_id = segmento.value;
        const res = await saveDataMarca(data);

        if (res === true) {
          toast.success("Marca cadastrada com sucesso");
          functionThatResetsFileds();
          formRef.current.reset();
          setSegmento(null);
          setImage(null);
          Swal.close();
        } else {
          Swal.close();
          toast.error("Ocorreu um erro tente novamente mais tarde!");
        }
      } else {
        if (image === null) {
          setErroImagem(true);
        } else if (segmento === null) {
          setErroSegmento(true);
        }
      }
    } catch (err) {
      const validationErrors = {};
      Swal.close();
      if (err instanceof ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
        toast.error("Verifique os campos em vermelho!");
      } else {
        toast.error("Ocorreu um erro tente novamente mais tarde!");
      }
    }
  }

  async function saveDataMarca(data) {
    try {
      await api.post(`/marca`, data);
    } catch (err) {
      toast.error("Ocorreu um erro ao salvar marca");
      throw err;
    } finally {
      return true;
    }
  }

  function functionThatResetsFileds() {
    let randomString = Math.random().toString(36);

    setKey({
      theInputKey: randomString,
    });
  }

  const debounceConsulta = async (body) => {
    return await new Promise((resolve) => {
      clearTimeout(timeoutConsulta);

      timeoutConsulta = setTimeout(() => {
        resolve(filtrarConsulta(body));
      }, 500);
    });
  };

  async function filtrarConsulta({ value = "", param }) {
    const result = await api.get(`options/segmentos?${param}=${value}`);
    return result.data.map((marcaParceiro) => ({
      value: marcaParceiro.id,
      nome: marcaParceiro.nome,
    }));
  }

  function useDisplayImage() {
    const [result, setResult] = React.useState("");

    function uploader(e) {
      if (e.target.files[0]) {
        setResult(`url(${URL.createObjectURL(e.target.files[0])})`);
      } else {
        setResult(null);
      }
    }
    return { result, uploader };
  }

  const { result, uploader } = useDisplayImage();

  return (
    <>
      <Row>
        <Col lg={7}>
          <h5 className="txt-tertiary">Criar marca</h5>
        </Col>
      </Row>
      <Form
        className="card-form"
        onSubmit={(data) => {
          handleSubmit(data);
        }}
        ref={formRef}
      >
        <Row>
          <Col lg={2}>
            <div class="avatar-upload">
              <span className="placholder-top">
                Imagem - Tamanho 1MB
              </span>
              <div class="avatar-edit">
                <input
                  type="file"
                  id="imageUpload"
                  accept=".png, .jpg, .jpeg"
                  onChange={(e) => {
                    if (e.target.files[0]?.size > 1000000) {
                      setImage(null);
                      toast.error("Imagem deve conter tamanho máximo de 1MB");
                    } else {
                      setImage(e.target.files[0]);
                      uploader(e);
                    }
                  }}
                />
                <label for="imageUpload"></label>
              </div>
              <label class="avatar-preview" for="imageUpload">
                <div
                  id="imagePreview"
                  style={{
                    background: result
                      ? result
                      : image
                      ? `url(${image})`
                      : "url(data:image/png;base64,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)",
                  }}
                ></div>
              </label>
            </div>
            {erroImagem && <small className="error">Obrigatório</small>}
          </Col>
          <Col lg={10}>
            <Row>
              <Col lg={12}>
                <span className="placholder-top">Nome da marca</span>
                <InputUnform
                  placeholder=""
                  type="text"
                  name="nome"
                  className="input-field-inner"
                />
              </Col>
              <Col lg={2}>
                <span className="placholder-top">Relevância</span>
                <InputUnform
                  placeholder=""
                  type="number"
                  min={1}
                  defaultValue={1}
                  name="relevancia"
                  className="input-field-inner"
                />
              </Col>
              <Col lg={5}>
                <span className="placholder-top">Segmento</span>
                <AsyncSelect
                  loadOptions={(value) =>
                    debounceConsulta({
                      value,
                      param: "nome",
                    })
                  }
                  name="segmento"
                  marca={true}
                  defaultOptions
                  getOptionLabel={(option) => option.nome}
                  onChange={setSegmento}
                  value={segmento}
                  cacheOptions
                  isClearable
                  error={erroSegmento}
                  placeholder={"Busque pelo segmento"}
                  noOptionsMessage={() => "Digite o segmento"}
                  key={(key && key.theInputKey) || ""}
                />
                {erroSegmento && <small className="error">Obrigatório</small>}
              </Col>
              <Col lg={5}>
                <span className="placholder-top">Subtítulo</span>
                <InputUnform
                  placeholder=""
                  type="text"
                  name="subtitulo"
                  className="input-field-inner"
                />
              </Col>
              <Col lg={12}>
                <span className="placholder-top">Descrição</span>
                <InputUnform
                  placeholder=""
                  type="text"
                  name="descricao"
                  className="input-field-inner"
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="mt-20">
          <Col className="justify-end">
            <Button color="green" className="btn-save mb-1">
              Criar
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default CriarMarca;
